import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { CopyClipboard, TextButton, TextButtonSkin } from '@wix/design-system';
import { DuplicateSmall } from '@wix/wix-ui-icons-common';
import { DataHooks } from '../../constants/dataHooks';
import { useSingleTemplateData } from '../../hooks/useSingleTemplateData';
import { useTemplatesPageBi } from '../../hooks/useTemplatesPageBi';

type Props = {
  dataHook?: string;
  valueToCopy: string;
  origin: string;
  skin?: TextButtonSkin;
};
export const CopyCodeToClipboard: FC<Props> = ({
  dataHook,
  valueToCopy,
  skin,
  origin,
}) => {
  const { t } = useTranslation();
  const { template } = useSingleTemplateData();

  const { reportCopyToClipboardClicked } = useTemplatesPageBi();
  const duplicateIcon =
    origin === 'markdown-codeblock'
      ? { prefixIcon: <DuplicateSmall /> }
      : { suffixIcon: <DuplicateSmall /> };

  return (
    <CopyClipboard dataHook={dataHook} value={valueToCopy} resetTimeout={1500}>
      {({ isCopied, copyToClipboard }) => (
        <TextButton
          dataHook={DataHooks.CodeBlockCopyToClipboardTextButton}
          size="small"
          weight="thin"
          skin={skin || 'standard'}
          onClick={() => {
            reportCopyToClipboardClicked(template.id, origin);
            copyToClipboard();
          }}
          {...duplicateIcon}
        >
          {t(
            `app.template-page.modal.terminal.tooltip.${
              isCopied ? 'copied' : 'copy'
            }`,
          )}
        </TextButton>
      )}
    </CopyClipboard>
  );
};
